import * as React from "react";
import {useEffect, useState} from "react";
import {completeDocumentOnClient} from "../../api";
import {useParams} from "react-router-dom";

const CustomerCompleteSignDocument: React.FunctionComponent = () => {

    const {documentId, keyId, profileId} = useParams();
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false)

    useEffect(() => {
        console.log("1");
        if (documentId) {
            console.log("2");
            setIsLoading(true);
            completeDocumentOnClient(documentId)
                .then((r) => {
                    console.log("3");
                    if (r.ok) {
                        setIsSuccess(true);
                    } else {
                        setError("Unable to save document")
                    }
                })
                .catch((e) => {
                    console.error(e);
                    setError("Unable to save document")
                })
                .finally(() => setIsLoading(false))
        }
    }, [documentId]);

    const getContent = () => {
        if (error) {
            return <h3>{error}</h3>
        }
        if (isLoading) {
            return <h3>Loading...</h3>
        }
        if (!isLoading && isSuccess) {
            return <h3>Thank you for signing the requested document!</h3>
        }
    }

    return <>
        <div className={"container"}>
            <div className={"row"}>
                <div className={"col-lg-12 mt-3 text-center"}>
                    <div className="row justify-content-md-center mb-3">
                        <img alt="logo" src="/assets/dist/img/promises12_logo.jpg"/>
                    </div>
                    <h3>{getContent()}</h3>
                </div>
            </div>
        </div>
    </>
}

export default CustomerCompleteSignDocument;